import React from 'react';

export const sectionTitleClassName = 'text-2xl font-semibold tracking-tight text-slate-950';
export const sectionSubtitleClassName = 'mt-2 max-w-2xl text-sm leading-6 text-slate-500';
export const inputClassName = 'mt-2 w-full rounded-2xl border border-blue-100 bg-white px-4 py-3 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-blue-400 focus:ring-4 focus:ring-blue-50';
export const readOnlyInputClassName = 'mt-2 w-full rounded-2xl border border-blue-100 bg-blue-50/60 px-4 py-3 text-sm text-slate-500 outline-none';
export const labelClassName = 'text-sm font-medium text-slate-700';
export const primaryButtonClassName = 'inline-flex items-center justify-center rounded-2xl bg-blue-600 px-5 py-3 text-sm font-semibold text-white transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-slate-300';
export const secondaryButtonClassName = 'inline-flex items-center justify-center rounded-2xl border border-blue-100 bg-white px-5 py-3 text-sm font-semibold text-blue-700 transition hover:bg-blue-50 disabled:cursor-not-allowed disabled:text-slate-400';
export const dangerButtonClassName = 'inline-flex items-center justify-center rounded-2xl border border-red-200 bg-red-50 px-5 py-3 text-sm font-semibold text-red-700 transition hover:bg-red-100 disabled:cursor-not-allowed disabled:border-slate-200 disabled:bg-slate-100 disabled:text-slate-400';

export const AccountSection = ({ eyebrow = 'Workspace', title, subtitle, actions, children }) => (
    <section className="space-y-8">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
            <div>
                <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-blue-500">{eyebrow}</p>
                <h2 className={sectionTitleClassName}>{title}</h2>
                {subtitle ? <p className={sectionSubtitleClassName}>{subtitle}</p> : null}
            </div>
            {actions ? <div className="flex flex-wrap gap-3">{actions}</div> : null}
        </div>
        {children}
    </section>
);

export const AccountCard = ({ children, className = '', muted = false }) => (
    <div className={`rounded-[28px] border ${muted ? 'border-blue-50 bg-blue-50/70' : 'border-blue-100/90 bg-white/98'} p-6 shadow-[0_16px_50px_rgba(30,64,175,0.08)] backdrop-blur ${className}`}>
        {children}
    </div>
);

export const AccountGrid = ({ children, className = '' }) => (
    <div className={`grid grid-cols-1 gap-5 xl:grid-cols-12 ${className}`}>
        {children}
    </div>
);

export const StatCard = ({ label, value, hint, accent = 'slate' }) => {
    const accentMap = {
        slate: 'bg-blue-600 text-white',
        blue: 'bg-blue-600 text-white',
        emerald: 'bg-sky-500 text-white',
        amber: 'bg-blue-100 text-blue-700',
    };

    return (
        <AccountCard className="flex min-h-[150px] flex-col justify-between">
            <div className={`h-10 w-10 rounded-2xl ${accentMap[accent] || accentMap.slate}`} />
            <div>
                <p className="text-sm text-slate-500">{label}</p>
                <p className="mt-2 text-2xl font-semibold tracking-tight text-slate-950">{value}</p>
                {hint ? <p className="mt-2 text-xs text-slate-400">{hint}</p> : null}
            </div>
        </AccountCard>
    );
};

export const SectionBadge = ({ children, tone = 'slate' }) => {
    const tones = {
        slate: 'border-blue-100 bg-blue-50 text-blue-700',
        green: 'border-sky-200 bg-sky-50 text-sky-700',
        blue: 'border-blue-200 bg-blue-50 text-blue-700',
        amber: 'border-sky-100 bg-sky-50 text-sky-700',
        red: 'border-red-200 bg-red-50 text-red-700',
    };

    return (
        <span className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold ${tones[tone] || tones.slate}`}>
            {children}
        </span>
    );
};
